import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data || !props.tasks) return data

    let tasks = !Array.isArray(props.tasks) ? [props.tasks] : props.tasks

    return {
      ...data,
      tasks,
      assignees: tasks.map(task => task.assignee?.user_id).filter(Boolean),
    }
  }, [data, props.tasks])
}
